import { useCardOfferPublisherContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';

import { LinkToPublisherProfile } from '../LinkToPublisherProfile';
import { PublisherLevelView } from '../PublisherLevelView';

export const PublisherNameWithBadges = memoWithDisplayName(() => {
  const publisher = useCardOfferPublisherContext();
  const { extendedProperties: { workHonestly } = {} } = publisher;

  return (
    <LinkToPublisherProfile
      as="UIHeading4"
      badges={!!workHonestly && <PublisherLevelView key="publisherLevelView" level={workHonestly.level} />}
      publisher={publisher}
      withTextOverflowEllipsis={false}
    />
  );
}, 'PublisherNameWithBadges');
